import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

export const LogoContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.2em;
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  min-height: 32px;
  cursor: pointer;
  transition: gap 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;

  &:hover {
    gap: 0em;
    padding-right: 1em;
  }

  &:hover .middle-dot {
    transform: translateY(-0.55em);
    opacity: 0;
    width: 0;
  }

  &:hover .i-letter::before {
    background-color: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? '#D4856C' : '#B85C38'};
    opacity: 1;
  }
`;

export const LogoText = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
`;

export const MiddleDot = styled.span.attrs({
  className: 'middle-dot',
})`
  color: ${({ theme }: { theme: ThemeInterface }) =>
    theme.name === 'short' ? '#D4856C' : '#B85C38'};
  transform: translateY(-0.1em);
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const ILetter = styled.span.attrs({
  className: 'i-letter',
})`
  position: relative;
  display: inline-block;

  &::before {
    content: '';
    position: absolute;
    top: 0.05em;
    left: 50%;
    transform: translateX(-50%);
    width: 0.15em;
    height: 0.15em;
    border-radius: 50%;
    background-color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
    opacity: 0;
    transition: background-color 0.6s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
